// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3on5O","avatar":"style_avatar__-HFta","menuIcon":"style_menuIcon__1xAdP"};